import Products from 'merchandise-lib/constants/Product';
import { useProductDetailsForArray } from '../product/useProductDetails';

/**
 * This hook is used to determine if the Marketing Plus product experience should be shown.
 *
 * @returns {
 *  loading: boolean;
 *  showMarketingPlus: boolean;
 * }
 */
export const useMarketingPlus = () => {
  var _productDetails$produ;
  const {
    productDetails,
    loading
  } = useProductDetailsForArray({
    productApiNames: [Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL, Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE]
  });
  const hasMarketingPlusSkus = Object.keys((_productDetails$produ = productDetails === null || productDetails === void 0 ? void 0 : productDetails.productsByName) !== null && _productDetails$produ !== void 0 ? _productDetails$produ : {}).length > 0;
  return {
    loading,
    showMarketingPlus: hasMarketingPlusSkus
  };
};